import { useEffect } from 'react'
import { useLocation } from 'react-router-dom';

const ScrollTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
  
      const onBeforeUnload = () => {
        window.scrollTo(0, 0);
      };
      window.addEventListener("beforeunload", onBeforeUnload);
  
      return () => {
        window.removeEventListener("beforeunload", onBeforeUnload);
      };
    }, [pathname]);
  
    return null;
}

export default ScrollTop